// Component: GlassPanel.jsx
// Purpose: DS GlassPanel primitive — frosted translucent surface (.glass-panel,
//          token-backed, theme-aware). Thin wrapper; className/style passthrough
//          and ref forwarding so it can host any content (overlays, hero cards).

import React, { forwardRef } from "react";
import { cx } from "./cx";

export const GlassPanel = forwardRef(function GlassPanel(
  { className, children, ...props },
  ref
) {
  return (
    <div ref={ref} className={cx("glass-panel", className)} {...props}>
      {children}
    </div>
  );
});

export default GlassPanel;
